import { Subscription } from 'rxjs/Subscription';
import { BalanceService, CurrencyType } from '@app/core/balance.service';
var CurrencySelectorComponent = /** @class */ (function () {
    function CurrencySelectorComponent(balance) {
        this.balance = balance;
        this.ignoreCoins = [];
        this.showCoins = false;
        this.items = [
            { value: CurrencyType.BTC, text: 'Bitcoin (BTC)' },
            { value: CurrencyType.ETH, text: 'Ethereum (ETH)' },
            { value: CurrencyType.LTC, text: 'Litecoin (LTC)' },
            { value: CurrencyType.EDG, text: 'Edgeless (EDG)' },
            { value: CurrencyType.DAI, text: 'FIAT (USD / EUR / GBP)' },
        ];
        this.sub = new Subscription();
        this._value = this.balance.getCurrency();
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    CurrencySelectorComponent.prototype.ngOnInit = function () {
        // this.sub.add(
        //   this.gs.currencyChange
        //     .pipe(filter((currency: PlayerCurrency) => currency !== this.value))
        //     .subscribe((currency: PlayerCurrency) => {
        //       this.value = currency;
        //     })
        // );
    };
    CurrencySelectorComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    CurrencySelectorComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    CurrencySelectorComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    CurrencySelectorComponent.prototype.setDisabledState = function (isDisabled) { };
    Object.defineProperty(CurrencySelectorComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (v) {
            this._value = v;
            this.onChange(this._value);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencySelectorComponent.prototype, "list", {
        get: function () {
            var _this = this;
            return this.items.filter(function (item) { return !_this.ignoreCoins.includes(item.value); });
        },
        enumerable: true,
        configurable: true
    });
    CurrencySelectorComponent.prototype.writeValue = function (obj) {
        this._value = obj;
    };
    CurrencySelectorComponent.prototype.getLabelByKey = function (key) {
        return this.items.find(function (item) { return item.value === key; }).text;
    };
    return CurrencySelectorComponent;
}());
export { CurrencySelectorComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/currency-selector.component.ts.pre-build-optimizer.js